import { isEmpty } from 'lodash';

export const mergeHostOptions = (availableOptions = [], rulesetDetail) => {
  if (isEmpty(rulesetDetail?.users)) {
    return availableOptions;
  }

  const currentlySelectedHosts = rulesetDetail?.users?.map((user) => ({
    id: user?.id,
    name: user?.name,
    isPregnancy: user?.isPregnancy,
  }));

  return [...availableOptions, ...currentlySelectedHosts];
};
